import React from "react"

function About() {
  return (
    <div className="about container">
      <h1 className="title aboutTitle">About</h1>

      <p style={{marginTop: "50px"}}>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aut porro
        accusamus tempora obcaecati perferendis tenetur quia aliquam facere
        inventore fugiat at autem odit laboriosam minima ad itaque, quidem
        dolorum ea maiores eos! Suscipit at iusto nisi necessitatibus. Adipisci
        eos et minus ratione esse sed consequatur tenetur, necessitatibus
        reiciendis nostrum. Soluta, iste! Saepe laborum expedita perferendis ea
        eos itaque. Perspiciatis perferendis architecto quaerat tempora,
        mollitia tempore asperiores molestiae minus quod maxime consequatur
        aliquid quibusdam alias harum ad aperiam dolores. Sapiente architecto
        consequuntur saepe iusto iure optio, eaque nobis quidem, mollitia
        recusandae molestiae enim cumque velit repellendus aliquam? Quae
        consequatur labore quaerat.
      </p>

      <br/>

      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid numquam inventore quasi. Aliquam omnis consequatur doloremque iusto mollitia quis laboriosam quisquam quaerat in, dolores eius cum vero. Maxime ut similique corrupti repellendus eos quibusdam perferendis dolorem error repudiandae eligendi, odit distinctio molestias facilis corporis voluptas omnis provident ab. Ea asperiores animi consequuntur eaque sequi numquam ab quis nobis unde alias, quisquam earum dignissimos pariatur inventore quos? Dolore, necessitatibus quia nisi sed sunt error quo, fugit cumque, accusamus modi beatae. Ea tempora officiis voluptatum maiores laudantium nihil, hic vel molestias reiciendis nisi repellendus? Ipsum nobis ullam alias corporis fuga architecto consectetur.</p>

      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid numquam inventore quasi. Aliquam omnis consequatur doloremque iusto mollitia quis laboriosam quisquam quaerat in, dolores eius cum vero. Maxime ut similique corrupti repellendus eos quibusdam perferendis dolorem error repudiandae eligendi, odit distinctio molestias facilis corporis voluptas omnis provident ab. Ea asperiores animi consequuntur eaque sequi numquam ab quis nobis unde alias, quisquam earum dignissimos pariatur inventore quos? Dolore, necessitatibus quia nisi sed sunt error quo, fugit cumque, accusamus modi beatae. Ea tempora officiis voluptatum maiores laudantium nihil, hic vel molestias reiciendis nisi repellendus? Ipsum nobis ullam alias corporis fuga architecto consectetur.</p>

    </div>
  )
}

export default About
